import { useState } from "react";
import { useAuthHeader, useAuthUser } from "../../../Services/Auth/sessionAuth";
import { Button, Form, Radio, Space, Spin, Tabs } from 'antd';
import Utilisateur from "../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";
import Tab1 from "./Tab1";
import { Box, Typography } from '@mui/material';
import Tab4 from './Tab1';
import SearchModal from "../../SearchModal";
import InputForm from "../../InputT";
import SelectOption from "../../SelectOption";
import DataSelect from '../../../Types/DataSelect'
import ParamsPicklist from "../../../Types/ParamsPicklist";
import SearInputG from "../../SearchInput"
import { Crypter } from "../../../Functions/Security/Crypter";
import Data from '../../../Data/Data.json';
import axios from "axios";
import ReformatDate from '../../../Functions/Traitement/ReformatDate'
import Demand from '../../../Models/MTypepret';
import formatDate from "../../../Functions/Traitement/fomatDate";
import { date } from "yup";
import CheckBox from "../../CheckBox";
import type { CheckboxChangeEvent } from 'antd/es/checkbox';

import CheckStan from "../../Prints/CheckStan";

//pour le compte de groupe
let searchTYPEPRET: ParamsPicklist = { CodeAgence: '', Table: "TYPEPRET", Colonne1: "TYPEPRET", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }

//pour le Plancp
let searchPlancp: ParamsPicklist = { CodeAgence: '', Table: "PLANCP", Colonne1: "IDPLAN", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }


const OperaSysteme = () => {

    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const authHeader = useAuthHeader()
    const [Onfinis, SetOnfinis] = useState<number>(0);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [SearchGlobal, setSearchGlobal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Supprimactv, setSupprime] = useState(true);
    const [Enregactv, setEnrege] = useState(true);
    const [Actuactv, setActue] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [sbmit, setSbmit] = useState("")
    const [Idbutton, setIdbutton] = useState(false);
    const [Idbutton2, setIdbutton2] = useState(true);
    const [Activetabs, SetActivetabs] = useState(false);

    // Handle function
    function HandleConsult() {
        setConsulte(true);
        setAjoute(true);
        setModife(false);
        setAnnule(false);
        setSupprime(false);
        setIdbutton(true);
        SetActivetabs(true)
        setIdbutton2(true);
    }

    function HandleAjout() {
        form.resetFields();
        setConsulte(true);
        setAjoute(true);
        setEnrege(false);
        setActue(false);
        setAnnule(false);
        setFormactve(false);
        setSbmit('add');
        setIdbutton2(false);

    }

    function HandleModif() {
        setEnrege(false);
        setModife(true);
        setActue(false);
        setAnnule(false)
        setFormactve(false);
        setSbmit('modif')
        setSupprime(true)
        SetActivetabs(false)
        setIdbutton2(false);
    }

    function HandleSupp() {
        setSbmit('supp')
    }

    function HandleAnnul() {

        setConsulte(false);
        setAjoute(false);
        setModife(true);
        setEnrege(true);
        setSupprime(true);
        setActue(true);
        setAnnule(true);
        form.resetFields();
        setFormactve(true);
        setSbmit('')
        setIdbutton(false);
        SetActivetabs(false)
        setIdbutton2(true);
    }



    // GESTION DES ITEMS
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='x'>
                    <UserOutlined />
                    Partie I
                </span>
            ),
            children: <>
                <div className='tabItem' >

                    <div style={{ display: 'block flow' }}  >
                        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  >

                            <Box style={{ display: 'flex' }}>

                                <Box style={{ width:600 }}>
                                    <fieldset className="bordure1" style={{ width:600 }} >
                                        <legend style={{ textAlign: "center", width: 200, paddingLeft: 10, borderRadius: 10 }} > Paramétre </legend>



                                        <Box style={{ marginBottom: -10, marginTop: -30 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Ajustement Devise ou TC" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Rception Fonds de Devise/TC" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Code Non Attribué" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Code Non Attribué" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Commission sur les Litiges" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Versements Déplacès" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Ccions/Mvts Déplacé" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Ccions/Ref en Cpt Epargne" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Ccions Périodiq de sécurité/C" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Agence Centrale de Mvts Déplacés" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Ccions sur Chèque Guichet" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Mise à disposition Envoi" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Cion/Escompte Chèque" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Refacture Frais Bancaire/Chèque" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>

                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Extourne Transfert" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Mise en Place Garantie Prêt" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Mise à Disposition Retrait" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                    </fieldset>
                                </Box>
                                <Box style={{ width:600 }}>
                                    <fieldset className="bordure1" style={{ width:600 }} >
                                        <legend style={{ textAlign: "center", width: 200, paddingLeft: 10, borderRadius: 10 }} > Paramétre </legend>



                                        <Box style={{ marginBottom: -10, marginTop: -30 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Emission Fonds Dévise/TC" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Montant Bloqué Via Prêt" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Prêt Social" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Code Non Attribué" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Frais Reléve Automatique" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Retrait Déplacés" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Mise à Zèro des Comptes" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Ccion Sécurité/Compte" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Ccion Collecte Journalière" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Consultation Cpt/Tel" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Frais Cloture Cpte" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Liste de Diffusion SMS" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Frais Banque Sur chèque" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Pénalité/Anticip DAT-BDC" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Pénalité/Modif Tranfert" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Promesse Octroi Prêt" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                    </fieldset>
                                </Box>




                            </Box>

                        </Box>
                    </div>
                </div >
            </>,
        },
        {
            key: '2',
            label: (
                <span id='x2'>
                    <ContactsOutlined />
                    Partie II
                </span>
            ),
            children: <>
                <div className='tabItem' >
                    <div style={{ display: 'block flow' }}  >
                        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  >

                            <Box style={{ display: 'flex' }}>

                                <Box style={{ width:600 }}>
                                    <fieldset className="bordure1"  style={{ width:600 }}>
                                        <legend style={{ textAlign: "center", width: 200, paddingLeft: 10, borderRadius: 10 }} > Paramétre </legend>



                                        <Box style={{ marginBottom: -10, marginTop: -30 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Ouverture de Compte" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Champ Non Utilisé" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Versement espèce" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Champ non Utilisé" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Virement Cpte Cpte" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Champ non Utilisé" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Sorties de Fonds" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Reception de Fonds" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Déficit de Fonds" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Dépôt à terme" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Cssion 1 Autori" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Cssion 3 Autori" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Cssion 2 Prêt" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Cssion 4 Prêt" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>

                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Mise en Place Prêt" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Mise En Place Prêt" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Intérêt crediteur Mensuel" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>

                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Instruction Permanente" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Achat Devise ou TC " name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Arrêté de Caisse" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Retour Chq.Impayé 2" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Commande Dévise ou TC" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                    </fieldset>
                                </Box>
                                <Box style={{ width:600 }}>
                                    <fieldset className="bordure1" style={{ width:600 }}>
                                        <legend style={{ textAlign: "center", width: 200, paddingLeft: 10, borderRadius: 10 }} > Paramétre </legend>



                                        <Box style={{ marginBottom: -10, marginTop: -30 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Mise En Place Chéquier" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Remise chéque Banque " name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Retrait Espèce" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Relévé des Comptes" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Ordre Permanent" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Entrées des Fonds" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Emission de Fonds" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Excédent de fonds" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Retour Chèque de Banque" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="M. en Pl. Autorisation" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Cssion 2 Autori" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Cssion 1 Prêt" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Cssion 3 Prêt" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Cssion 5 Prêt" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Intérêt Débiteur Mesure" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Commission Mensuel" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Collecte des Fonds" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Ventes Dévises ou TC" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Retour Ch. Impayé 1" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Prêts Impayés" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" Parametre={searchPlancp} label="Réception Dévise ou TC" name="" Taille1={120} Taille2={200} form={form} />
                                        </Box>

                                    </fieldset>
                                </Box>
                            </Box>

                        </Box>
                    </div>
                </div>
            </>,
        }
        // ,
        // {
        //     key: '3',
        //     label: (
        //         <span id='x3'>
        //             <ContactsOutlined />
        //             Partie III
        //         </span>
        //     ),
        //     children: <>
        //         <div className='tabItem' >
        //             <div style={{ display: 'block flow' }}  >
        //                 <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  >

        //                     <Box style={{ display: 'flex' }}>

        //                         <Box>
        //                             <fieldset className="bordure1" >
        //                                 <legend style={{ textAlign: "center", width: 200, paddingLeft: 10, borderRadius: 10 }} > Paramétre </legend>



        //                                 <Box style={{ marginBottom: -10, marginTop: -30 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                                 <Box style={{ marginBottom: -10, marginTop: -10 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                                 <Box style={{ marginBottom: -10, marginTop: -10 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                                 <Box style={{ marginBottom: -10, marginTop: -10 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                                 <Box style={{ marginBottom: -10, marginTop: -10 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                                 <Box style={{ marginBottom: -10, marginTop: -10 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                                 <Box style={{ marginBottom: -10, marginTop: -10 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                                 <Box style={{ marginBottom: -10, marginTop: -10 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                                 <Box style={{ marginBottom: -10, marginTop: -10 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                                 <Box style={{ marginBottom: -10, marginTop: -10 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                                 <Box style={{ marginBottom: -10, marginTop: -10 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                                 <Box style={{ marginBottom: -10, marginTop: -10 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                                 <Box style={{ marginBottom: -10, marginTop: -10 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                                 <Box style={{ marginBottom: -10, marginTop: -10 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                             </fieldset>
        //                         </Box>
        //                         <Box>
        //                             <fieldset className="bordure1" >
        //                                 <legend style={{ textAlign: "center", width: 200, paddingLeft: 10, borderRadius: 10 }} > Paramétre </legend>



        //                                 <Box style={{ marginBottom: -10, marginTop: -30 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                                 <Box style={{ marginBottom: -10, marginTop: -10 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                                 <Box style={{ marginBottom: -10, marginTop: -10 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                                 <Box style={{ marginBottom: -10, marginTop: -10 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                                 <Box style={{ marginBottom: -10, marginTop: -10 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                                 <Box style={{ marginBottom: -10, marginTop: -10 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                                 <Box style={{ marginBottom: -10, marginTop: -10 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                                 <Box style={{ marginBottom: -10, marginTop: -10 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                                 <Box style={{ marginBottom: -10, marginTop: -10 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                                 <Box style={{ marginBottom: -10, marginTop: -10 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                                 <Box style={{ marginBottom: -10, marginTop: -10 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                                 <Box style={{ marginBottom: -10, marginTop: -10 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                                 <Box style={{ marginBottom: -10, marginTop: -10 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                                 <Box style={{ marginBottom: -10, marginTop: -10 }}>
        //                                     <SearchModal width={0} Titre="" Parametre={searchPlancp} label="id plan compte " name="" Taille1={120} Taille2={200} form={form} />
        //                                 </Box>
        //                             </fieldset>
        //                         </Box>
        //                     </Box>

        //                 </Box>
        //             </div>
        //         </div>
        //     </>,
        // }
    ];

    // function consult 
    function consult() {
        if (form.getFieldValue("N") == null) {
            SweetAlert.fire({ title: "Svp renseigner le Id Type Prêt", icon: "warning" });
        } else {
            let data = (form.getFieldValue("TYPEPRET"));
            HandleConsult();

            if (data.length != 0) {
                setLoading(true)

                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.ReadTypepret,
                    headers: {
                        'CypherTypepret': data,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                };

                axios.request(config)
                    .then((response) => {
                        setLoading(false);
                        if (response.data) {
                            //const res = JSON.parse(Crypter.decrypt(response.data));
                            const res = JSON.parse(Crypter.decrypt(response.data));
                            //console.log(JSON.stringify(res))
                            let DemandVP = res.Result.Table[0]
                            console.log(DemandVP);

                            if (res.StatutCode == 200) {

                                form.setFieldsValue(DemandVP);
                                form.setFieldValue("lib_TYPEPRET", DemandVP.LIBELLE)

                            }
                            else {
                                SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                            }
                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log(error)
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                    });
            }
        }
    }

    // function Onfinish
    const onFinish = (values: any) => {

        console.log(values)
        var Demand: Demand = values
        Demand.LIBELLE = form.getFieldValue("lib_TYPEPRET")
        Demand.DATCRE = formatDate(Perss.datjour)
        Demand.codage = (Perss.codage)
        alert(" date" + Demand.codage)
        // ********************************************************************************************************************************  isModifDatEch
        if (sbmit == "add") {

            SweetAlert.fire({
                title: "Création d'un Type Prêt",
                text: "Voulez-vous Créer ce Type Prêt ",
                showCancelButton: true,
                color: "green",
                confirmButtonText: "Yes",
                confirmButtonColor: "green",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)
                    //console.log(JSON.stringify(DemandVP));

                    let data = Crypter.encrypt(JSON.stringify(Demand));
                    let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.CreateTypepret,
                        headers: {
                            'CypherTypepret': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        }
                    };
                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                let code = res.Result
                                console.log(Demand)

                                if (res.StatutCode == 200) {

                                    if (code == 'Existe') {
                                        SweetAlert.fire({ title: res.Message, text: "Ce code existe déja svp choisissez un autre", icon: "warning" })
                                    } else {

                                        //form.resetFields()
                                        //setIsSubmit(false)
                                        //HandleAnnul()
                                        SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                    }

                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }
        // ********************************************************************************************************************************
        if (sbmit == "modif") {



            SweetAlert.fire({
                title: "M.A.J d'un Type Prêt",
                text: "Voulez-vous mettre à jour ce Type Prêt ",
                showCancelButton: true,
                color: "green",
                confirmButtonText: "Yes",
                confirmButtonColor: "green",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)
                    //console.log(JSON.stringify(DemandVP));
                    let data = Crypter.encrypt(JSON.stringify(Demand));
                    let config = {
                        method: 'put',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.UpdateTypepret,
                        headers: {
                            'CypherTypepret': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                //console.log(res)
                                if (res.StatutCode == 200) {
                                    let code = res.Result

                                    setIsSubmit(false)
                                    HandleAnnul()
                                    SweetAlert.fire({ title: "Mise à jour Effectuer avec Success", text: "Code : " + res.Message, icon: "success" })

                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }
        // ********************************************************************************************************************************
        if (sbmit == "supp") {

            SweetAlert.fire({
                title: "Suppression d'un Type Prêt",
                text: "Voulez-vous Supprimer ce Type Prêt ",
                showCancelButton: true,
                color: "green",
                confirmButtonText: "Yes",
                confirmButtonColor: "green",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)
                    //console.log(JSON.stringify(DemandVP));
                    let data = Crypter.encrypt(JSON.stringify(Demand.TYPEPRET));
                    let config = {
                        method: 'delete',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.DeleteTypepret,
                        headers: {
                            'CypherTypepret': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                //console.log(res)
                                if (res.StatutCode == 200) {
                                    let code = res.Result
                                    if (res.Message == "Erreur") {
                                        SweetAlert.fire({ title: "Svp préciser le type de modification", icon: "warning" })
                                        //HandleAnnul()
                                    } else {
                                        setIsSubmit(false)
                                        HandleAnnul()
                                        SweetAlert.fire({ title: "Suppression Effectuer avec Success", text: "Code : " + res.Message, icon: "success" })
                                    }
                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }
    }

    // function de verification 
    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })
        SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            Swal.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> <b> Mise en place d'un Type de Prêt: {window.location.pathname.toUpperCase()} </b> </Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }}>
                <Form disabled={FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={Consultactv} onClick={() => { consult() }} type="ghost" htmlType="button" block  >
                                    Consulter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Ajoutactv} onClick={() => { HandleAjout() }} type="ghost" htmlType="button" block  >
                                    Ajouter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Modifactv} onClick={() => { HandleModif() }} type="ghost" htmlType="button" block  >
                                    Modifier
                                </Button>
                                <Button size='large' className='bt_add' disabled={Enregactv} type="ghost" htmlType="submit" block>
                                    Enregistrer
                                </Button>
                                <Button size='large' className='bt_add' disabled={Supprimactv} onClick={() => { HandleSupp() }} type="ghost" htmlType="submit" block>
                                    Supprimer
                                </Button>
                                <Button size='large' className='bt_add' disabled={Actuactv} onClick={() => { form.resetFields() }} type="ghost" htmlType="button" block  >
                                    Actualiser
                                </Button>
                                <Button size='large' disabled={Annulactv} onClick={() => { HandleAnnul() }} className='bt_add' type="ghost" htmlType="reset" block>
                                    Annuler
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs onChange={e => { if (Activetabs == true) { consult() } }} size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );



}

export default OperaSysteme;